import React, { useState } from 'react';

function Bulletpoints({ description }) {
  const [showAll, setShowAll] = useState(false);
  const points = description.split('\n');

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  const displayedItems = showAll ? points : points.slice(0, 2);

  return (
    <div>
      {displayedItems.map((point, idx) => (
        <p key={idx}>• {point}</p>
      ))}
      {points.length > 2 && (
        <p onClick={toggleShowAll} className="showmore">
          {showAll ? 'Show Less' : 'Show More'}
          <i
            className={`icon la ${showAll ? 'la-angle-up' : 'la-angle-down'}`}
          ></i>
        </p>
      )}
    </div>
  );
}

export default Bulletpoints;
